import Vue from 'vue'
import Vuex from 'vuex'

import message from './modules/message'
import users from './modules/users'
import loader from './modules/loader'
import blockScreen from './modules/blockScreen'
Vue.use(Vuex)

const state = {}
const actions = {}
const getters = {}
const mutations = {}

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    message,
    users,
    loader,
    blockScreen
  }
})